import React from 'react'
import Button from '@mui/material/Button'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { CircularProgress } from '@mui/material'

const ConfirmDialog = (props: {
  title: string
  children?: React.ReactNode
  open: boolean
  setOpen: (openState: boolean) => void
  onConfirm?: () => Promise<void> | void
  maxWidth?: DialogProps['maxWidth']
  fullWidth?: boolean
  confirmDisabled?: boolean
  confirmText?: string
  cancelText?: string
}) => {
  const {
    title,
    children,
    open,
    setOpen,
    onConfirm,
    maxWidth,
    fullWidth,
    confirmDisabled,
    confirmText = 'Ya',
    cancelText = 'Tidak',
  } = props
  const [isConfirming, setIsConfirming] = React.useState(false)

  const handleConfirm = async () => {
    if (onConfirm) {
      setIsConfirming(true)
      try {
        await onConfirm()
      } finally {
        setIsConfirming(false)
        setOpen(false)
      }
    } else {
      setOpen(false)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => !isConfirming && setOpen(false)}
      aria-labelledby="confirm-dialog"
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          color="secondary"
          disabled={isConfirming}
        >
          {cancelText}
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          color="primary"
          disabled={confirmDisabled || isConfirming}
        >
          {isConfirming ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            confirmText
          )}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default ConfirmDialog
